import axiosInstance from './axiosInstance'; 

export const fetchQuestions = async () => {
  const response = await axiosInstance.get('/questions/');
  return response.data;
};

export const submitQuestion = async (questionData) => {
  const response = await axiosInstance.post('/questions/create', questionData);
  return response.data;
};

export const deleteQuestion = async (questionId) => {
  const response = await axiosInstance.post(`/questions/${questionId}`);
  return response.data;
};


export const editQuestion = async (questionId, questionData) => {
  const response = await axiosInstance.put(`/questions/${questionId}`, questionData);
  return response.data;
};

export const updateQuestion = async (questionData) => {
  const response = await axiosInstance.post('/questions/update', questionData);
  return response.data;
};


export const uploadQuestions = async (file) => {
  const formData = new FormData();
  formData.append('document', file); 

  try {
    const response = await axiosInstance.post('/questions/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data; 
  } catch (error) {
    console.error('Upload failed:', error.response ? error.response.data : error.message);
    throw error;
  }
};

